module.exports = ".contentType{\r\n    margin-bottom: 10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/template-details/template-details.component.css
// module id = ./src/app/template-details/template-details.component.css
// module chunks = main